import { OptionalWrapper } from './optional.component';

export * from './optional.component';
export default OptionalWrapper;

OptionalWrapper.define('der-ui-optional-wrapper');

declare global {
    interface HTMLElementTagNameMap {
        'der-ui-optional-wrapper': OptionalWrapper;
    }
}
